import * as LJS from "../../lib/littlejs.esm";
import Globals from '../globals.ts';
import Object from "./object.ts";
class Heart extends Object {
    constructor(pos, world) {
        console.log("SPAWN HEART", pos, world);
        super(pos, 42, world, 40);
        this.fallDelay = 120;
        this.fallTimer = 0;
        this.isGoingToFall = false;
        this.isFalling = false;
        this.mass = 0; // Not affected by gravity
    }
    update() {
        super.update();
        if (this.disabled) {
            return;
        }
        // Check for overlap with player
        if (Globals.player && LJS.isOverlapping(this.pos, this.size, Globals.player.pos, Globals.player.size) && Globals.player.health < 3) {
            Globals.player.heal();
            this.destroy();
        }
    }
    defaultCollision() {
        this.setCollision(true, false, false, false);
    }
}
export default Heart;
